import { graphicsManager } from "appworks/graphics/graphics-manager";
import { DualPosition } from "appworks/graphics/pixi/dual-position";
import { Contract } from "appworks/utils/contracts/contract";
import { logger } from "appworks/utils/logger";
import { getOffsetPosition } from "appworks/utils/position-offset-calculator";
import { Timer } from "appworks/utils/timer";
import { gameLayers } from "game-layers";
import { AnimateOverSymbolBehaviour } from "slotworks/components/matrix/symbol/behaviours/animate-over-symbol-behaviour";

export class TGRSymbolSpineAnimateBehaviour extends AnimateOverSymbolBehaviour {

    public behaviourName: string = "TGRSymbolSpineAnimate";

    public cycle(): Contract<void> {
        return this.spineAnimation(1.2, this.symbol.symbolId);
    }

    public win(): Contract<void> {
        return this.spineAnimation(1, this.symbol.symbolId);
    }

    public highlight(): Contract<void> {
        return this.spineAnimation(1, `${this.symbol.symbolId}_win`);
    }

    private spineAnimation(animationSpeed: number, animationName: string): Contract<void> {
        return new Contract((resolve: (value?: any) => void) => {
            const spine: PIXI.spine.Spine = graphicsManager.createSpine(this.symbol.symbolId);
            let trackEntry: PIXI.spine.core.TrackEntry;
            if (spine.state.hasAnimation(animationName)) {
                trackEntry = spine.state.setAnimation(0, animationName, false);
            } else {
                trackEntry = spine.state.setAnimation(0, this.symbol.symbolId, false);
            }

            if (trackEntry) {
                const rect: DualPosition = gameLayers.MatrixContent.getPosition(`${this.symbol.symbolId}_spine`);
                if (rect) {
                    const x: number = this.symbol.gridPosition.x;
                    const y: number = this.symbol.gridPosition.y;
                    const offset: DualPosition = getOffsetPosition(gameLayers.MatrixContent, "symbol_0_0", `symbol_${x}_${y}`);
                    gameLayers.SymbolAnimations.add(spine);
                    spine.setTransform(rect.landscape.x + offset.landscape.x, rect.landscape.y + offset.landscape.y);
                    spine.width = rect.landscape.width;
                    spine.height = rect.landscape.height;
                    spine.state.timeScale = animationSpeed;

                    spine.state.addListener({ complete: () => {
                        spine.state.clearTrack(trackEntry.trackIndex);
                        Timer.setTimeout(() => {
                            gameLayers.SymbolAnimations.remove(spine);
                            resolve();
                        }, 0);
                    } });
                } else {
                    logger.error("TGRSymbolSpineAnimate - Spine POSITION not found for ", this.symbol.symbolId);
                }
            } else {
                logger.error("TGRSymbolSpineAnimate - Spine ANIMATION not found for ", this.symbol.symbolId);
            }
        });
    }
}
